import { render, staticRenderFns } from "./m_company010.vue?vue&type=template&id=4bb16484&scoped=true&"
import script from "./m_company010.vue?vue&type=script&lang=js&"
export * from "./m_company010.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb16484",
  null
  
)

export default component.exports